<template>
  <article class="">
      <cabecera></cabecera>
     <section class="cabecera">
      <img src="./cabecera.jpg" alt="" >
      <h2>Comprometidos con un <br>desarrollo sostenible</h2>
    </section>
     <section class="cont-1300">
      <div class="right">
        <img src="./1.jpg" alt="">
      </div>
      <div class="left">
        <h2>
         Medio Ambiente y Seguridad
        </h2>
        <div class="zurda zurdas">
          <ul class="owl-carousel">
            <li class="slide slide1">
              <p>
              Nuestro Sistema de Gestión Integrado está integrado por la familia de normas ISO referidas a sistemas de calidad, seguridad y salud ocupacional, ambiente y de gestión de la energía.<br><br>
              En <strong>Compañía Mega S.A.</strong> hemos definimos la Política de Gestión la cual está fundada sobre los 4 pilares éticos de la organización <strong>(Respeto, Integridad, Transparencia y Seguridad)</strong> desde aquí se desprenden nuestros <strong>Valores</strong> que están comprendidos dentro de la <strong>Visión</strong> de la misma.<br><br>

              El Equipo de Dirección ha establecido una serie de acciones
              concretas relacionadas con el desarrollo eco-eficiente,
              enunciados dentro de la Política de Gestión. 
              </p>
            </li>
            <li class="slide slide2">
              <p>
                  A través de estas acciones la Compañía asume un compromiso en el cumplimiento de la legislación y las reglamentaciones
                  ambientales, priorizando la prevención de impactos ambientales antes que la corrección de los mismos, colaborando con las
                  distintas partes interesadas en la búsqueda de soluciones a los problemas relacionados con el medioambiente; asimismo
                  involucramos a nuestros contratistas mediante el cumplimiento de criterios ambientales, teniendo en cuenta las medidas o
                  tecnologías que pudieran ser aplicadas a fin de generar una mejora significativa en aspectos relacionados con el
                  medioambiente.
                </p>
            </li>
          </ul>
        </div>
      </div>
    </section>

      <section class="cont-1300 cont-premio">
        <div class="right">
          <h2>Premios</h2>
          <div class="zurda zurdas">
            <p><a href="https://www.linkedin.com/company/ciamega/" targeg="_blank">COMPAÑÍA MEGA</a> recibió el “<strong>Premio Anual a la Seguridad</strong>” del IAPG <strong>en los rubros empresas Refinadores/Comercializadoras y Distribuidoras</strong>. Este premio reconoce a aquellas compañías que lograron la más destacada actuación en materia de seguridad. <br><br>Este reconocimiento nos llena de orgullo ya que refuerza firmemente la cultura de nuestra Política de gestión; impulsar la seguridad y la integridad, junto con la calidad, la eficiencia y el respeto por el medio ambiente, que son los pilares fundamentales del desempeño global del negocio, de la relaciones con los clientes y con nuestro grupo de interés. <br><br>También hemos sido reconocidos por el CEM (<a href="https://www.linkedin.com/company/clean-energy-ministerial/" target="_blank">Clean Energy Ministerial</a>) por nuestra labor en materia de Eficiencia Energética; fuimos galardonados con el Premio 2021 Energy Management Insight Award.<br><br>Este reconocimiento refleja nuestro desarrollo en materia de Eficiencia Energética y los beneficios obtenidos por la implementación de la norma ISO 50001. Es un gran honor ser reconocidos entre destacadas compañías internacionales, ya que consideramos que el reconocimiento otorgado nos desafía a continuar por este camino y refuerza el compromiso de nuestra organización con el uso eficiente de la energía y la sustentabilidad de los recursos.</p>
          </div>
        </div>
        <div class="left">
          <img src="./premio2022.jpg" alt="">
        </div>
      </section>

    <section class="acciones">
      <div class="cont-1170">
        <h2>Acciones concretas de desarrollo eco-eficiente</h2>
        <div class="mod">
          <ul>
            <li><img src="./check.png" alt=""> 
              Reciclado de residuos.
            </li>
            <li><img src="./check.png" alt=""> Cambio de tecnología de diseño en antorchas de gases para el menor consumo de gas combustible y en control de emisiones.</li>
            <li><img src="./check.png" alt=""> Estudios de calidad de aire y emisiones gaseosas.</li>
             <li><img src="./check.png" alt=""> Aprovechamiento de nitrógeno residual como gas de sweeping para disminuir el consumo de gas combustible.</li>
            <li><img src="./check.png" alt=""> Disminución de la generación de residuos especiales.</li>
             <li><img src="./check.png" alt=""> Incorporación de equipamiento específico en compresor BOG para reducir consumo de energía eléctrica.</li>
            <li><img src="./check.png" alt=""> Incorporación de turbina para aprovechamiento de salto de presión.</li>
            <li><img src="./check.png" alt=""> Forestación dentro del predio industrial aprovechando el tratamiento de efluentes cloacales.</li>
             <li><img src="./check.png" alt=""> Adquisición de equipamiento de laboratorio que nos permite eficientizar el monitoreo y procesos productivos.</li>
            <li><img src="./check.png" alt=""> Estudios de factibilidad técnico/económica de aprovechamiento de gases de escape de turbinas.</li>
            <li><img src="./check.png" alt=""> Reducción de emisión de humo a la atmósfera.</li>
            <li><img src="./check.png" alt=""> Tratamiento de la corriente de anhídrido carbónico.</li> 
          </ul>
        </div>
        <video controls src="./video.mp4"></video>
      </div>
    </section>
     <span id="sistema-de-gestion"></span>
    <section class="acciones">
      <div class="cont-1170">
        <h2>Sistema de Gestión Integrado</h2>
        <div class="mod">
         <p><strong>Compañía Mega S.A.</strong>, implementó un Sistema de Gestión Integrado desde el 1 de noviembre de 2002 y a través de las auditorías
        externas de mantenimiento y de recertificación por parte del Ente Certificador Internacional se va robusteciendo y consolidando vez tras vez nuestro sistema. Hoy acreditamos el cumplimiento de los requisitos de las normas <strong>ISO 9001:2015</strong> (Sistemas de Gestión de la Calidad), <strong>ISO 45001:2018</strong> (Sistemas de Gestión de la Seguridad y Salud en el Trabajo), <strong>ISO 14001:2015</strong> (Sistemas de Gestión Ambiental) e <strong>ISO 50001:2018</strong> (Sistemas de Gestión de la Energía), las cuales son aplicables al proceso de separación, transporte, fraccionamiento y almacenamiento de los componentes líquidos del gas natural, despacho y venta de productos.<br><br>

        La implementación y mantenimiento del Sistema de Gestión Integrado basado en las Normas ISO (sistema certificado de tetranormas) resulta de gran desafío para la Compañía, teniendo en cuenta las diferentes localizaciones, contextos, culturas y procesos operativos. Esto significa que la estandarización, la optimización de los procesos y la mejora continua es parte de la genética y de los estándares
        de la Compañía.</p>
        </div>
        <div class="caja">
           <a href="static/pdf/COMPAÑIA%20MEGA%20S.A.%20(OAA%209001-2015)%20CERTIFICATE%20AR-O240585%20v01.pdf" target="_blank"><img  src="./1c.png"  alt=""></a>
           <a href="static/pdf/COMPAÑIA MEGA S.A. (OAA 14001-2015) CERTIFICATE AR-O240586 v01.pdf" target="_blank"><img  src="./2c.png"  alt=""></a>
           <a href="static/pdf/COMPAÑIA MEGA S.A. (UKAS 45001-2018) CERTIFICATE AR-U240587 v01.pdf" target="_blank"><img  src="./3c.png"  alt=""></a>
           <a href="static/pdf/Certificado 50001-2018.pdf" target="_blank"><img  src="./4c.png"  alt=""></a>
         </div>
      </div>
    </section>
      <section class="accionest acciones">
      <div class="cont-1170">
        <h2>Política y Principios de Gestión</h2>
         <img class="imgs" src="./4.png"  alt="">
      </div>
    </section>
    <pie></pie>
  </article>
</template> 

<script>
import $ from 'jquery'
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel'
import Cabecera from '@/components/Cabecera'
import Pie from '@/components/Pie'
export default {
  name: 'medioAmbiente',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted: function () {
    $('.zurda > ul').owlCarousel({
      autoplay: false,
      items: 1,
      loop: true,
      slideSpeed: 1000,
      autoplaySpeed: 500,
      singleItem: true,
      dragBeforeAnimFinish: false,
      mouseDrag: true,
      touchDrag: true,
      nav: true,
      dots: false
    })
  },
  components: {
    Cabecera,
    Pie
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.owl-nav
  .owl-prev
    font-size: 40px !important
  .owl-next
    font-size: 40px !important
.comercio
  padding: 80px 0
  position: relative
  &:after
    content: ''
    height: 400px
    background: #004d9e
    width: 100%
    position: absolute
    z-index: 1
    top: 0
  h1
    text-align: center
    color: #fff
    font-size: 30px
    width: 100%
    position: relative
    z-index: 2
  .cont-1170
    max-width: 1170px
    display: flex
    flex-direction: column
    align-items: center
    padding-top: 40px
    width: 100%
    padding: 0 15px
    margin: 0 auto
    position: relative
    z-index: 2
    img
      max-width: 800px
      width: 100%
      margin: 0 auto
    video
      max-width: 700px
      width: 100%
      margin: 0 auto
      padding-top: 50px
.acciones
  background: #f5f6f6
  padding: 80px 0
  .cont-1170
    max-width: 1170px
    width: 100%
    padding: 0 15px
    margin: 0 auto
    display: flex
    flex-direction: column
    align-items: center
    h2 
       font-size: 30px 
       color: #004d9e
       padding-bottom: 20px
    .mod
      p
        font-size: 16px
        line-height: 30px
        color: #323232
        padding: 5px 20px
        margin-bottom: 30px
      ul
        width: 100%
        display: flex
        flex-wrap: wrap
        justify-content: space-between
        @media(max-width: 1200px)
          flex-direction: column
          justify-content: center
        li
          width: 45%
          position: relative
          font-size: 16px
          color: #323232
          line-height: 30px
          @media(max-width: 1200px)
            width: 100%
            padding-left: 20px
          img
            position: absolute
            left: -20px
            top: 9px
            @media(max-width: 1200px)
              left: 0

    .imgs
      max-width: 900px
      width: 100%
    .img
      margin-top: 30px
      max-width: 700px
      width: 100%
    video
      max-width: 1000px
      width: 100%
      margin: 0 auto
      padding-top: 60px
.accionest
  background: #fff
  h1
    padding-bottom: 40px
.secundario p 
  margin-bottom: 10px
.cabecera
  width: 100%
  position: relative
  img
    width: 100%
    @media (max-width: 550px)
     height: 160px
  h2
    position: absolute
    top: 40%
    left: 50%
    font-size: 36px
    color: #fff
    transform: translateX(-50%)
    @media (max-width: 550px)
      top: 30%
      font-size: 28px
      text-align: center
      width: 100%
.cont-1300
  display: flex
  align-items: center
  max-width: 1300px
  width: 100%
  padding: 0 15px
  margin: 0 auto
  @media(max-width: 800px)
    flex-direction: column
  .left
    width: 50%
    padding: 0 50px
    @media(max-width: 800px)
      width: 100%
      padding: 30px 10px
    h2
      font-size: 30px
      color: #004d9e
      position: relative
      margin-bottom: 60px
      &:after
        width: 80px
        height: 1px 
        background: #333
        content: ''
        position: absolute
        bottom: -30px
        left: 0
    p
      font-size: 16px 
      line-height: 30px
      color: #323232
  .right
    width: 50%
    @media(max-width: 800px)
      width: 100%
      margin-bottom: 20px
    video, img
      width: 100%
</style>

<style scoped lang="sass">
.cont-premio
  .right
    width: 50%
    padding: 0 50px
    margin-top: 10px
    @media(max-width: 800px)
      width: 100%
      padding: 30px 10px
    h2
      font-size: 30px
      color: #004d9e
      position: relative
      margin-bottom: 60px
      &:after
        width: 80px
        height: 1px 
        background: #333
        content: ''
        position: absolute
        bottom: -30px
        left: 0
    p
      font-size: 16px 
      line-height: 30px
      color: #323232
      a
        color: blue
  .left
    width: 50%
    padding: 0 0px
    align-self: baseline
    @media(max-width: 800px)
      width: 100%
      margin-bottom: 20px
    img
      width: 100%
      min-height: 900px
      object-fit: cover
      @media(max-width: 800px)
        min-height: auto







</style>


// WEBPACK FOOTER //
// src/components/medio-ambiente/medioAmbiente.vue